<template>
  <div class="magazine-giftcard">
    <div class="magazine-giftcard__images">
      <div class="magazine-giftcard__image">
        <img :src="image1" loading="lazy" alt="" />
      </div>
      <!-- Request by Francesca to remove the second image -->
      <!-- <div class="magazine-giftcard__image">
        <img :src="image2" loading="lazy" alt="" />
      </div> -->
    </div>
    <div class="magazine-giftcard__form">
      <div class="text-xl font-bold mb-1">
        {{ title || t('giftcard.magazineTitle') }}
      </div>
      <GiftcardBuyBox is-magazine class="w-full" />
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

withDefaults(
  defineProps<{
    title?: string
    image1?: string
    image2?: string
  }>(),
  {
    title: '',
    image1:
      'https://d1sos1r10s6do5.cloudfront.net/cms-media/tufting_f2fe8ea286.jpg',
    image2:
      'https://d1sos1r10s6do5.cloudfront.net/cms-media/malkurs_6d9232748c.jpg',
  }
)
</script>

<style lang="css">
@reference '~/assets/css/tailwind.css';
.magazine-giftcard {
  @apply flex flex-col md:flex-row gap-3 md:gap-8 border border-gray-300 rounded-3xl p-3 md:p-6 my-8;

  &__images {
    @apply flex gap-4;
  }

  &__image {
    @apply w-[162px] h-[150px] md:w-[308px] md:h-full relative flex;

    img {
      @apply w-full! h-full object-cover rounded-xl !m-0;
    }
  }

  &__form {
    @apply flex-1;
  }
}
</style>
